import { MouseEvent, ReactNode } from 'react';

import type { StimulusResourceFragment } from '../../../shared/stimulus/stimulus.graphql.generated';
import type { GetComponentTemplatesQuery } from '../../lesson-builder.graphql.generated';
import { JSONObject } from 'global/graphql/scalars.type';
import { ComponentTemplates } from 'global/constants';
import type { ComponentDataInput } from '../../../../gql/schema-types';
import type { Pluck } from 'lib/gql/pluck';

export enum MenuCategory {
  Activity = 'Activity',
  Text = 'Text',
  Image = 'Image',
  Stimulus = 'Stimulus',
  Columns = 'Columns',
}

export type MenuItems = {
  section: MenuCategory;
  items: MenuItem[];
};

export type MenuItem = {
  onClick: (stimulus?: StimulusResourceFragment) => void;
  getPayload: () => AddComponentTemplate;
} & Pluck<GetComponentTemplatesQuery, 'getComponentTemplates'>;

export type MenuData = {
  section: MenuCategory;
  label: string;
  items: MenuItem[];
};

export type AddComponentTemplate = {
  templateId: ComponentTemplates;
  isSubActivity: boolean;
  optimisticComponent: JSONObject;
  componentData?: ComponentDataInput;
  defaultSubActivityData?: {
    areInstructionsVisible: boolean;
  };
  stimulus?: StimulusResourceFragment;
};

export type ComponentMenuRenderProp = {
  render: (onClick: (e: MouseEvent<HTMLButtonElement>) => void) => ReactNode;
};
